<xemex-dialog-shell
  [title]="
    (isEdit ? 'devices.pvForecast.dialog.editTitle' : 'devices.pvForecast.dialog.createTitle')
      | translate
  "
>
  <xemex-pv-forecast-form [form]="form" [emeterChannels]="data.emeterChannels" />

  @if (errorMessage()) {
    <p class="mt-4 text-sm text-text-error" role="alert">{{ errorMessage() }}</p>
  }

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button type="button" intent="primary" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    @if (data.emeterChannels.length > 0) {
      <xemex-filled-button type="button" [loading]="isSaving()" (click)="onSave()">
        {{ (isEdit ? 'general.btnSaveChanges' : 'general.btnCreate') | translate }}
      </xemex-filled-button>
    }
  </div>
</xemex-dialog-shell>
